<template>
  <div
    class="image-chooser"
    :class="{open}"
  >
    <div
      v-if="image"
      class="backdrop"
    />
    <div class="inner">
      <img
        v-if="value && image === null"
        :src="value"
      >
      <image-uploader
        v-else
        v-model="image"
        :ratio="ratio"
      />
      <div class="image-opts">
        <a
          v-if="value && image === null"
          class="btn btn-primary"
          href="#"
          @click.prevent="handleChangeImage()"
        >Change</a>
        <a
          v-if="value && image === null"
          class="btn btn-primary"
          href="#"
          @click.prevent="handleRemoveImage()"
        >Remove</a>
        <a
          v-if="image"
          class="btn btn-primary"
          href="#"
          @click.prevent="handleAcceptImage()"
        >Accept</a>
        <a
          v-if="image"
          class="btn btn-primary"
          href="#"
          @click.prevent="handleCancelImage()"
        >Cancel</a>
        <a
          v-if="image === '' && value"
          class="btn btn-primary"
          href="#"
          @click.prevent="handleCancelImage()"
        >Revert</a>
      </div>
    </div>
  </div>
</template>

<script>
import ImageUploader from '@virgodev/vue-image-crop/image_uploader.vue';
import { thumbnail } from '@virgodev/vue-image-crop/utils';

export default {
  name: 'ImageChooser',
  components: {
    ImageUploader,
  },
  props: {
    value: { type: String, default: null },
    ratio: { type: Number, default: 1 },
  },
  data() {
    return {
      open: false,
      image: null,
    };
  },
  watch: {
    image() {
      if (this.image) {
        this.open = true;
      }
    },
  },
  methods: {
    handleChangeImage() {
      this.image = '';
    },
    async handleAcceptImage() {
      this.$emit('input', await thumbnail(this.image, 512));
      this.image = null;
      this.open = false;
    },
    handleCancelImage() {
      this.image = null;
      this.open = false;
    },
    handleRemoveImage() {
      this.$emit('input', '');
      this.image = null;
      this.open = false;
    },
  },
};
</script>

<style scoped>
  .image-chooser.open {
    position: fixed;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    display: flex;
  }
  .backdrop {
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    background: black;
    opacity: 0.5;
    z-index: 1;
  }
  .image-chooser.open .inner {
    padding: 5px;
    margin: auto;
    background: white;
    width: 600px;
    max-width: calc(100% - 10px);
    place-self: center;
    z-index: 2;
    border-radius: 3px;
    box-shadow: 0 2px 3px #444;
  }
  img {
    max-width: 200px;
  }
  .image-opts {
    margin-top: 5px;
  }
</style>
